export * from 'react-dictate-button-mocked-speech-recognition';
